<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goBack()">{{ 'portalCustomization.back' | translate }}</button>
    </app-page-header>
    <div class="personalize-content">
      <div class="second-headboard">
        <h1>{{ 'portalCustomization.title' | translate }}</h1>
        <!-- <img src="../../../assets/icons/3412.png" alt="logo de Billcentrix"> -->
        <div class="linked-icons" >
          <button (click)="goBack()" >{{ 'portalCustomization.steps.template' | translate }}</button>
          <button  class="active">{{ 'portalCustomization.steps.customization' | translate }}</button>
          <button>{{ 'portalCustomization.steps.activate' | translate }}</button>
          <!-- <img src="../../assets/icons/1_cuenta_off.png" alt="Paso 1: Cuenta" (click)="goToAccount()" >
          <img src="../../assets/icons/2_portales_off.png" alt="Paso 2: Portal" (click)="goBack()" >
          <img src="../../assets/icons/3_personalizar_on.png" alt="Paso 3: Personalizar" >
          <img src="../../assets/icons/4_planes_off.png" alt="Paso 4: Planes" (click)="goToPlans()"> -->
        </div>
      </div>
      <div class="options-content">
        <!-- <div class="selected-theme">
        <h1>Tema seleccionado: <strong>{{ selectedTheme }}</strong></h1>
        <p>Puedes cambiar el template cuando quieras</p>
        <div class="change-btn">
          <button mat-icon-button [matMenuTriggerFor]="menuPlan">Cambiar</button>
          <mat-menu #menuPlan="matMenu" class="menu">
            <button mat-menu-item (click)="changeTheme('Básico')">Básico</button>
            <button mat-menu-item (click)="changeTheme('Práctico')">Práctico</button>
            <button mat-menu-item (click)="changeTheme('Contempo')">Contempo</button>
          </mat-menu>
        </div>
      </div> -->
      <app-slider (paletteSelected)="handlePaletteSelected($event)"></app-slider>
      <div class="brand">
        <h1>{{ 'portalCustomization.yourBrand' | translate }}</h1>
        <div class="grid-brand">
          <div class="upload-file">
            <p class="principal-text">{{ 'portalCustomization.uploadLogo' | translate }}</p>
            <div class="upload">
              <img src="../../../assets/icons/subir.png" alt="subir archivo">
              <p class="action-description">{{ 'portalCustomization.uploadFile' | translate }}</p>
            </div>
            <div class="preview">
              <!-- <img src="../../../assets/icons/ver.png" alt="vista previa">
              <p class="action-description">Vista previa</p> -->
              <input class="upload-photo" type="file" id="formFile" accept="image/png, image/jpeg, .svg"  (change)="onLogoChange($event)" >
            </div>
          </div>
          <div class="image-width">
            <div class="line-horizontal"></div>
            <span class="line-text-horizontal">200 pixels</span>
            <div class="line-vertical"></div>
            <span class="line-text-vertical">50 pixels</span>
            <img src="../../../assets/images/BRAND3.png" alt="medidas del logo">
            <br>
              <br>
                <br>
                  @if (logo64) {
                    <img [src]="logo64" alt="foto" width="250" height="100">
                  }
                </div>
              </div>
            </div>
            <div class="main-image">
              <div class="grid-main-image">
                <div class="left">
                  <h1>{{ 'portalCustomization.mainImage' | translate }}</h1>
                  <p class="principal-text">{{ 'portalCustomization.mainImageDescription' | translate }}</p>
                  <div class="upload">
                    <img src="../../../assets/icons/subir.png" alt="subir archivo">
                    <p class="action-description">{{ 'portalCustomization.uploadFile' | translate }}</p>
                  </div>
                  <div class="preview">
                    <input class="upload-photo" type="file" id="formFile" accept="image/png, image/jpeg, image/svg"  (change)="onPrincipalChange($event)" >

                    <!-- <img src="../../../assets/icons/ver.png" alt="vista previa">
                    <p class="action-description">Vista previa</p> -->
                  </div>
                  <div class="sample-measurements">
                    <div class="line-horizontal"></div>
                    <span class="line-text-horizontal">1440 pixels</span>
                    @if (principal64) {
                      <img style="margin-top: 2em; margin-left: 2em;width: 80%;" [src]="principal64" alt="foto" width="710" height="180">
                    }
                    <div class="line-vertical"></div>
                    <span class="line-text-vertical">720 pixels</span>
                  </div>
                </div>
                <div class="right">
                  <img class="section" src="../../../assets/images/indicadores-pag.png" alt="sectores de la pagina">
                  <img class="sample" src="../../../assets/images/pag-min.png" alt="muestra de la pagina">
                </div>
              </div>
            </div>
            <div class="promotional-banner">
              <div class="grid-promotional-banner">
                <div class="left">
                  <h1>Banner promocional</h1>
                  <p class="principal-text">Esta imagen será mostrada en la parte final del portal, puede ser
                    una
                    imagen promocional o
                    una segunda imagen representativa del portal. Use una imagen tipo .jpg para el mejor y
                    rápido desempeño de su portal sin sacrificar calidad. El tamaño recomendado: 320 x 400
                  pixels.</p>
                  <div class="upload">
                    <img src="../../../assets/icons/subir.png" alt="subir archivo">
                    <p class="action-description">Subir archivo</p>
                  </div>
                  <div class="preview">
                    <!-- <img src="../../../assets/icons/ver.png" alt="vista previa">
                    <p class="action-description">Vista previa</p> -->
                    <input class="upload-photo" type="file" id="formFile" accept="image/png, image/jpeg, image/svg"  (change)="onPromotionalChange($event)" >

                  </div>
                  <div class="frequent-questions">
                    <!-- <img src="../../../assets/icons/informacion2.png" alt="icono preguntas frecuentes">
                    <p>Haz clic aquí para preguntas frecuentes</p> -->
                  </div>
                </div>
                <div class="right">
                  <div class="sample-measurements">
                    <div class="line-horizontal"></div>
                    <span class="line-text-horizontal">320 pixels</span>
                    @if (promotional64) {
                      <img style="margin-top: 2em; margin-left: 2em;" [src]="promotional64" alt="foto" width="160" height="260">
                    }
                    <div class="line-vertical"></div>
                    <span class="line-text-vertical">400 pixels</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="main-image">
              <div class="grid-main-image">
                <div class="left">
                  <h1>Datos generales del portal</h1>
                  < <div class="grid-general-data">
                  <div class="left">
                    <div class="items">
                      <label for="image-title">Título para la imagen principal</label>
                      <input  [formControl]="form.controls['page_title']" type="text" placeholder="Ej. Bienvenidos a Club Platino">
                      @if (form.controls['page_title'].hasError('required') && form.controls['page_title'].touched) {
                        <small
                        class="form-error-msg"> Título para la imagen es requerido </small>
                      }
                    </div>
                    <div class="items">
                      <label for="description">Descripción de la página</label>
                      <textarea type="textarea" [formControl]="form.controls['description_page']"
                      placeholder="Ej. Servicio dedicado a suplir a la audiencia amante de los vinos, se ofrece aquí un servicio de suscripción a los mejores precios y con extraordinaria calidad."></textarea>
                      @if (form.controls['description_page'].hasError('required') && form.controls['description_page'].touched) {
                        <small
                        class="form-error-msg"> Descripción es requerido </small>
                      }
                    </div>

                    <div class="items">
                      <label for="action">Título para planes</label>
                      <input [formControl]="form.controls['price_title']"  type="text" placeholder="¡Ej. Suscríbase ya!">
                      @if (form.controls['price_title'].hasError('required') && form.controls['price_title'].touched) {
                        <small
                        class="form-error-msg"> Título para precio es requerido </small>
                      }
                    </div>
                  </div>
                  <div class="rihgt">
                    <div class="items">
                      <label for="banner-text">Título banner producto</label>
                      <input [formControl]="form.controls['banner_title']" type="text" placeholder="Ej. Aprovecha nuestra oferta con la promoción...">
                      @if (form.controls['banner_title'].hasError('required') && form.controls['banner_title'].touched) {
                        <small
                        class="form-error-msg"> Texto del banner es requerido </small>
                      }
                    </div>
                    <div class="items">
                      <label for="banner-description">Descripción del banner del producto</label>
                      <input [formControl]="form.controls['description_banner']"  type="text" placeholder=" Ej.Oferta del día de la madre">
                      @if (form.controls['description_banner'].hasError('required') && form.controls['description_banner'].touched) {
                        <small
                        class="form-error-msg"> Descripción del banner es requerido </small>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="right">
                <img class="sample" src="../../../assets/images/datosPortalpng.png" alt="muestra de la pagina">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <!-- <div class="preview-mobile">
        <button class="back-btn" (click)="preview()">Vista previa</button>
      </div> -->
      <div class="action-buttons">
        <button class="back-btn" (click)="goBack()">Atrás</button>
        <!-- <button class="finish" (click)="sendConfiguration()"*ngIf="exist" >Guardar y continuar</button> -->
        <!-- <button class="finish" (click)="sendConfiguration()"  *ngIf="!exist">Continuar</button> -->
      </div>
      <div class="action-buttons">
        <!-- <button class="finish" (click)="preview()">Vista previa</button> -->
        <button class="finish" (click)="sendConfiguration()">Guardar y continuar</button>
      </div>
    </div>
  </div>
</body>